













import { Component, Mixins } from "vue-property-decorator";
import { StandardTextDrawableObjectDrawerBase } from "./base";
import { TableIndexPropertyPresentableMixin } from "../../mixins";
import { default as NamedRectangleCoordinatableObjectDrawer } from "./NamedRectangleCoordinatableObjectDrawer.vue";

@Component({
  components: {
    NamedRectangleCoordinatableObjectDrawer,
  },
})
export default class ScriptLinkObjectDrawer extends Mixins(StandardTextDrawableObjectDrawerBase, TableIndexPropertyPresentableMixin) {
  get displayName(): string {
    return this.name !== ""
      ? this.name + "[" + this.tableIndex.row + "][" + this.tableIndex.column + "]"
      : "";
  }
}
